module.exports = __webpack_public_path__ + "static/media/6.87cae948.jpg";